module.exports = __webpack_public_path__ + "static/assets/5f485ea6671fddc6ed1c80da98a261c9.svg";